var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container container-narrow" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.ranks") } }),
        _vm.emptyPage
          ? _c("article", { staticClass: "message is-success" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("ranking.empty"))),
              ]),
            ])
          : _vm._e(),
        _vm.errorPage
          ? _c("article", { staticClass: "message is-danger" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.error"))),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "tabs is-centered" }, [
          _c("ul", [
            _c("li", { class: _vm.tabMonthClass }, [
              _c(
                "a",
                { attrs: { tab: "month" }, on: { click: _vm.changeTab } },
                [_vm._v(_vm._s(_vm.$t("ranking.tab_month")))]
              ),
            ]),
            _c("li", { class: _vm.tabFullClass }, [
              _c(
                "a",
                { attrs: { tab: "full" }, on: { click: _vm.changeTab } },
                [_vm._v(_vm._s(_vm.$t("ranking.tab_full")))]
              ),
            ]),
          ]),
        ]),
        !_vm.loading &&
        !_vm.emptyPage &&
        ((_vm.activeTab === "month" && _vm.ranksMonth.length === 0) ||
          (_vm.activeTab === "full" && _vm.ranksFull.length === 0))
          ? _c("article", { staticClass: "message is-warning" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("ranking.empty"))),
              ]),
            ])
          : _vm.activeTab === "month"
          ? _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "table-container" }, [
                !_vm.loading
                  ? _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _c(
                              "abbr",
                              { attrs: { title: _vm.$t("ranking.position") } },
                              [_vm._v("#")]
                            ),
                          ]),
                          _c("th", { staticStyle: { width: "100%" } }, [
                            _vm._v(_vm._s(_vm.$t("ranking.name"))),
                          ]),
                          _c("th", [_vm._v(_vm._s(_vm.$t("ranking.score")))]),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.ranksMonth, function (user, index) {
                          return _c("tr", { key: user.uuid }, [
                            _c("th", [_vm._v(_vm._s(index + 1))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  user.nickname
                                    ? user.nickname
                                    : user.first_name + " " + user.last_name
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "no-wrap" }, [
                              _vm._v(_vm._s(user.score)),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm.activeTab === "full"
          ? _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "table-container" }, [
                !_vm.loading
                  ? _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _c(
                              "abbr",
                              { attrs: { title: _vm.$t("ranking.position") } },
                              [_vm._v("#")]
                            ),
                          ]),
                          _c("th", { staticStyle: { width: "100%" } }, [
                            _vm._v(_vm._s(_vm.$t("ranking.name"))),
                          ]),
                          _c("th", [_vm._v(_vm._s(_vm.$t("ranking.score")))]),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.ranksFull, function (user, index) {
                          return _c("tr", { key: user.uuid }, [
                            _c("th", [_vm._v(_vm._s(index + 1))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  user.nickname
                                    ? user.nickname
                                    : user.first_name + " " + user.last_name
                                )
                              ),
                            ]),
                            _c("td", { staticClass: "no-wrap" }, [
                              _vm._v(_vm._s(user.score)),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }